<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_DataPushResultRecords')"
      @close="innerVisible=false"
    >
      <div>
        <el-form label-width="100px" label-position="left">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('CargoMsg.Cargo_PaymentReceiveMethod')">
                <el-select v-model="filter.accountReceivable" filterable clearable>
                  <el-option v-for="(item,index) in CHANGE_CHARGE_CHARGETYPE" :key="index" :label="item.chineseName" :value="item.code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 发送日期 -->
              <el-form-item :label="$t('CargoMsg.Cargo_SendDate')">
                <el-date-picker
                  v-model="filter.dateCreated"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  style="width:220px;"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 发送状态 -->
              <el-form-item :label="$t('CargoMsg.Cargo_ResultSuccess')">
                <el-select v-model="filter.sendStatus" filterable clearable>
                  <el-option v-for="(item,index) in SEND_STATUS" :key="index" :label="item.chineseName" :value="item.code" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <!-- 发送类型	 -->
              <el-form-item :label="$t('CargoMsg.Cargo_SendType')">
                <el-select v-model="filter.sendType" filterable clearable>
                  <el-option v-for="(item,index) in SEND_TYPE" :key="index" :label="item.chineseName" :value="item.code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 结算对象 -->
              <el-form-item :label="$t('SeaExport.AccountObject')">
                <cargo-advance-select
                  :select-type="TYPE_NAMES.basic_data_Company"
                  filterable
                  clearable
                  :default-value="filter.accountId"
                  options-width="200px;"
                  tag-value="cmpIdx"
                  tag-name="chineseName"
                  @parentCallBack="p=>filter.accountId=p.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button type="primary" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'100%',height:'450px'}"
        />
      </div>
      <span slot="footer">
        <el-button
          v-if="$checkPermission(['button_financeModule_ReissueFees'])"
          type="primary"
          @click="toReissueFees"
        >{{ $t('CargoMsg.Cargo_ReissueFees') }}<i class="el-icon-question" style="margin-left: 10px" :title="$t('CargoMsg.Cargo_ReissueFeesTips')" /></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { CHANGE_CHARGE_CHARGETYPE } from '@/class/cargo/model/parameters/ChangeChargeConstant'
import { SEND_STATUS, SEND_TYPE } from '@/class/cargo/model/parameters/SystemConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { queryChargePushRecord, reSendChargePushRecord } from '@/api/clearing/charge'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'DataPushResultRecordsDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true }
  },
  data() {
    return {
      filter: {
        accountReceivable: null,
        dateCreated: null,
        sendStatus: null,
        accountId: null,
        sendType: null
      },
      TYPE_NAMES,
      CHANGE_CHARGE_CHARGETYPE,
      SEND_STATUS,
      SEND_TYPE,
      loading: false,
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_Sender'), field: 'createdBy', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('FinanceManage.receivablePayable'), field: 'accountReceivable', width: 150,
          valueFormatter: params => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        { headerName: this.$t('FinanceManage.domestic_chargeAmount'), field: 'amount', width: 150,
          valueFormatter: params => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SendType'), field: 'sendType', width: 180,
          cellRenderer: (params) => {
            return CommonState.getNameByCode(this.SEND_TYPE, params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SendDate'), field: 'dateCreated', width: 150 },
        { headerName: this.$t('CargoMsg.Cargo_ResultSuccess'), field: 'sendStatus', width: 150,
          cellRenderer: (params) => {
            return CommonState.getNameByCode(this.SEND_STATUS, params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ResultMessage'), field: 'sendMessage', width: 150,
          cellRenderer: (params) => {
            return params.data.sendStatus === 1 ? '' : params.value
          } }
      ],
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      if (!this.jobUuid) {
        this.$message.warning(this.$t('Message.BusinessCannotBeEmpty'))
        return
      }
      const params = this.filter
      params.jobUuid = this.jobUuid
      if (params.dateCreated) {
        params.beginDate = params.dateCreated[0] + ' 00:00:00'
        params.endDate = params.dateCreated[1] + ' 23:59:59'
      } else {
        delete params.beginDate
        delete params.endDate
      }
      this.loading = getLoading()
      queryChargePushRecord(params).then(res => {
        this.loading.close()
        this.rowData = res.data
      }).catch(() => {
        this.loading.close()
      })
    },
    toReissueFees() {
      //
      this.loading = getLoading()
      reSendChargePushRecord({ uuid: this.jobUuid }).then(res => {
        this.loading.close()
        this.toQuery()
      }).catch(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog{
  width: 1000px !important;
}
</style>

